module.exports = __webpack_public_path__ + "img/users-minus.fb1aa547.svg";